import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../main/content/base/base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn } from '@angular/forms';
import { DateHelper } from 'app/main/content/misc/date.module';

@Component({
  selector: 'select-date',
  templateUrl: './selectDate.component.html',
  styleUrls: ['./selectDate.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectDateComponent extends BaseComponent implements OnInit {

  title: string;
  message: string;
  minDate: any;
  maxDate: any;
  date1Label = 'From';
  date2Label = 'To';
  showDate2 = true;
  form: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<SelectDateComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dateHelper: DateHelper,
              private fb: UntypedFormBuilder) {
    super();
    this.title = data.title;
    this.message = data.message;
    this.minDate = data.minDate;
    this.maxDate = data.maxDate;
    this.date1Label = data.date1Label || 'From';
    this.date2Label = data.date2Label || 'To';
    this.showDate2 = data.showDate2;
  }

  ngOnInit(){
    this.form = this.fb.group({
      date1: [this.data.date1, Validators.required],
      date2: [this.data.date2, Validators.required],
    }, { validator: this.valMinMax });
  }

  public confirmSubmit(): void {
    this.data.date1 = this.form.controls['date1'].value;
    this.data.date2 = this.form.controls['date2'].value;
    this.dialogRef.close({
      date1: this.data.date1,
      date2: this.data.date2,
    });
  }

  // custom validator for date1 > date2
  // if valid returns null, else returns a string (minmaxerror) to identify this specific error
  // check this in the template as form.errors?.minmaxerror
  valMinMax: ValidatorFn = (control: UntypedFormGroup) => {
    let min = null; 
    let max = null; 
    if (this.showDate2){
      // use the date helper to get an absolute date - this ensures the min/max are valid in respect to each other
      min = this.dateHelper.relativeToAbsolute(control.get('date1').value);
      if (min) { min = min.valueOf(); }
      max = this.dateHelper.relativeToAbsolute(control.get('date2').value);
      if (max) { max = max.valueOf(); }

      if (min && max){
        let err = (min > max);
        if (!err){
          err = this.dateHelper.isRelativeDate(control.get('date1').value) && (!this.dateHelper.isRelativeDate(control.get('date2').value));
        }
        return (err) ? { minmaxerror: true } : null;
      }
    }
  else{
    return null;
  }
  }

}
